import { useState, useEffect } from 'react';
import { getUserColor } from '../../utils/function';
import { Tooltip } from 'bootstrap';

export const MembersData = ({ user }) => {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl); // Initialize the tooltip using imported Tooltip
    });
  }, []);
  const [usertoggle, setUserToggle] = useState(false);

  let shortName = user.name
    .split(' ')
    .slice(0, 2)
    .map((word) => word[0])
    .join('');
  // console.log("shortName",shortName);

  return (
    <li class="remove-card-member-list">
      {/* <div onClick={() => setUserToggle(!usertoggle)}>Click Demo</div> */}
      <div class="dropdown show">
        <button
          class={'btn btn-secondary color' + getUserColor(shortName)}
          type="button"
          title={user.name}
          data-bs-toggle="tooltip"
          data-placement="bottom"
          onClick={() => setUserToggle(!usertoggle)}
        >
          {shortName}
        </button>
        {usertoggle ? (
          <div class="dropdown-menu profile-card" x-placement="bottom-start">
            <div class="pchead">
              <div class="pc-name">
                <button class="close-btn-pop" onClick={setUserToggle(false)}>
                  <span class="material-symbols-outlined">close</span>
                </button>
                <div class="short-name">
                  <span class={'color' + getUserColor(shortName)}>
                    {shortName}
                  </span>
                </div>
                <div class="short-detail">
                  <h3>{user.name}</h3>
                  <h4>@defaultuser</h4>
                </div>
              </div>
            </div>
            {/* <a href="javascript:void(0);" class="view-profile">
            View Profile
          </a> */}
            <div class="pcfoot">
              <a href="javascript:void(0);" class="view-profile">
                Remove from card
              </a>
            </div>
          </div>
        ) : (
          ''
        )}
        {/* {usertoggle ? 'abc' : 'def'} */}
      </div>
    </li>
  );
};
